import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("sb-spinner")
export class SbSpinner extends LitElement {
  createRenderRoot() {
    return this; // light DOM
  }

  /** Diameter in px */
  @property({ type: Number }) size = 16;

  /** Stroke thickness */
  @property({ type: Number, attribute: "stroke-width" }) strokeWidth = 2;

  /** Color (defaults to currentColor) */
  @property() color: string = "currentColor";

  /** Accessible label */
  @property() label: string = "Loading…";

  @property({ type: Number }) duration = 1;

  render() {
    const radius = Math.max(0, (this.size - this.strokeWidth) / 2);
    const circumference = 2 * Math.PI * radius;
    const normalizedRadius = radius - this.strokeWidth / 2;

    return html`
      <style>
        .chrome-spinner {
          width: ${this.size}px;
          height: ${this.size}px;
          display: inline-block;
          animation: chrome-spinner-rotate ${this.duration}s linear infinite;
        }

        .chrome-spinner-circle {
          stroke: ${this.color};
          stroke-width: ${this.strokeWidth};
          stroke-linecap: round;
          fill: none;
          transform-origin: 50% 50%;
          stroke-dasharray: ${circumference};
          stroke-dashoffset: 0;
          animation: chrome-spinner-dash ${this.duration}s linear infinite;
        }

        @keyframes chrome-spinner-rotate {
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes chrome-spinner-dash {
          0% {
            stroke-dashoffset: ${circumference};
            transform: rotate(0deg);
          }
          50% {
            stroke-dashoffset: ${circumference * 0.2};
            transform: rotate(180deg);
          }
          100% {
            stroke-dashoffset: ${circumference};
            transform: rotate(360deg);
          }
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          margin: -1px;
          padding: 0;
          border: 0;
          clip: rect(0 0 0 0);
          clip-path: inset(50%);
          overflow: hidden;
          white-space: nowrap;
        }
      </style>

      <svg
        class="chrome-spinner"
        viewBox="0 0 ${this.size} ${this.size}"
        role="status"
        aria-live="polite"
      >
        <circle
          class="chrome-spinner-circle"
          cx="${this.size / 2}"
          cy="${this.size / 2}"
          r="${normalizedRadius}"
        ></circle>
      </svg>
      ${this.label ? html`<span class="sr-only">${this.label}</span>` : null}
    `;
  }
}
